const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://kmvoa3fvlj.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://whfuonvi8l.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://eyx6520x30.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.3',
    HOSTNAME: 'https://locations.testing.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://0bmk6ppdq1.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;